import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatLoungeResultCard, RuleActionExtension } from '@sabstravtech/obtservices/base';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { formatCardCurrency, policyStatusClass, policyStatusLabel } from '../chat-card.util';

@Component({
  selector: 'app-chat-lounge-card',
  standalone: false,
  templateUrl: './chat-lounge-card.component.html',
  styleUrls: ['./chat-lounge-card.component.scss']
})
export class ChatLoungeCardComponent {
  @Input() card!: ChatLoungeResultCard;
  /** ENT-16247 — id of the assistant message these results belong to. */
  @Input() feedbackBaseId = '';
  @Output() cardClick = new EventEmitter<void>();

  /** ENT-16247 — synthetic feedback id, unique per card. */
  get feedbackId(): string {
    return `${this.feedbackBaseId || 'card'}::lounge-${this.card.index}`;
  }

  /** ENT-16247 — short card summary sent as the feedback assistantResponse. */
  get feedbackSummary(): string {
    return `Lounge ${this.card.name}, ${this.card.price} ${this.card.currency || ''}`.trim();
  }

  readonly selectLabel = $localize`:@@chatLoungeSelect:Select`;
  readonly faLocationDot = faLocationDot;

  get policyClass(): string {
    return policyStatusClass(this.card.policyStatus);
  }

  /** Lounge name without the trailing "- N hours" pass-duration suffix (QA: match mockup). */
  get displayName(): string {
    return (this.card.name ?? '').replace(/\s*[-–]\s*\d+\s*hours?\b.*$/i, '').trim();
  }

  get policyLabel(): string {
    return policyStatusLabel(this.policyClass);
  }

  /** Quote's policy fields, shaped for `app-warning-tags` — the same
   *  indicator/tooltip component the results page uses, so the chat card and
   *  results page render identically instead of a bespoke text box. */
  get headlineWarningTicket(): RuleActionExtension {
    return {
      unavailable: !!this.card.unavailable,
      unavailableMessage: this.card.unavailableMessage || '',
      requiresReasonKeys: this.card.requiresReasonKeys || [],
      requiresReasonMessages: this.card.requiresReasonMessages || []
    };
  }

  /** Select the card unless the quote is out of policy and disallowed. */
  onCardClick(): void {
    if (this.card.unavailable) return;
    this.cardClick.emit();
  }

  get formattedPrice(): string {
    if (this.card.unavailable) {
      return '';
    }
    return formatCardCurrency(this.card.price, this.card.currency || 'GBP');
  }
}
